import { makeStyles, TableCell, TableHead, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import ColumnTooltip from './ColumnTooltip';

const useStyles = makeStyles(theme => {
  const { palette, customStyles } = theme;

  return {
    header: {
      height: customStyles.tableHeader.height,
      backgroundColor: palette.primary.main,
      '& th': {
        padding: customStyles.tableHeader.padding,
        fontSize: customStyles.tableHeader.fontSize,
        lineHeight: customStyles.tableHeader.lineHeight,
        color: palette.white,
        '& svg': {
          fontSize: customStyles.headerSvg.fontSize,
          marginLeft: customStyles.headerSvg.marginLeft
        },
        '&:nth-child(2)': {
          maxWidth: customStyles.nthChild.maxWidth
        },
        boxShadow: showHeaderBorder =>
          showHeaderBorder ? `inset 0 5px ${palette.primary.dark}` : '',
        '& span': {
          width: '100%'
        },
        '&:not(last-child)': {
          borderLeft: `1px solid ${palette.white}`
        }
      }
    },
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      userSelect: 'none'
    }
  };
});

const TableHeader = ({
  columns,
  onColumnSort,
  showHeaderBorder,
  firstColumnFixedWidth,
  columnFixedWidth
}) => {
  const classes = useStyles(showHeaderBorder);
  const getWidth = index => {
    if (index === 0 && firstColumnFixedWidth) {
      return `${firstColumnFixedWidth}px`;
    }
    if (columnFixedWidth) {
      return `${columnFixedWidth}px`;
    }

    return null;
  };

  return (
    <TableHead>
      <TableRow className={classes.header}>
        {columns.map((column, index) => {
          if (column.key === 'timeserieslinkid' || column.key === 'timeserieslinktype') {
            return null;
          }

          if (column.key === 'stocklink') {
            return null;
          }

          return (
            <TableCell width={getWidth(index)} key={column.key || column.name}>
              <div className={classes.label}>
                {column.title}
                {onColumnSort && column.isSortable && (
                  <ColumnTooltip column={column} onSort={onColumnSort} />
                )}
              </div>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  onColumnSort: PropTypes.func,
  showHeaderBorder: PropTypes.bool,
  firstColumnFixedWidth: PropTypes.number,
  columnFixedWidth: PropTypes.number
};

TableHeader.defaultProps = {
  showHeaderBorder: true,
  firstColumnFixedWidth: null,
  columnFixedWidth: null,
  onColumnSort: null
};

export default TableHeader;
